import React from 'react';
import { Tag } from 'antd';
import { CheckCircleOutlined, ClockCircleOutlined, MinusCircleOutlined, PieChartOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
export const paymentTones = {
  Paid: { color: '#166534', background: '#DCFCE7', borderColor: '#86EFAC', chart: '#16A34A' },
  Unpaid: { color: '#991B1B', background: '#FEE2E2', borderColor: '#FCA5A5', chart: '#DC2626' },
  'Partially paid': { color: '#9A3412', background: '#FFEDD5', borderColor: '#FDBA74', chart: '#EA580C' },
  'Not set': { color: '#854D0E', background: '#FEF9C3', borderColor: '#FDE047', chart: '#EAB308' },
  Overdue: { color: '#991B1B', background: '#FEE2E2', borderColor: '#FCA5A5', chart: '#DC2626' },
};
const icons = { Paid: <CheckCircleOutlined />, Unpaid: <ClockCircleOutlined />, 'Partially paid': <PieChartOutlined />, 'Not set': <MinusCircleOutlined />, Overdue: <ExclamationCircleOutlined /> };
export default function PaymentStatus({ status = 'Not set' }) {
  const tone = paymentTones[status] || paymentTones['Not set'];
  return <Tag style={{ color: tone.color, background: tone.background, borderColor: tone.borderColor, fontWeight: 600, borderRadius: 6, padding: '3px 9px' }} icon={icons[status]} aria-label={`Payment: ${status}`}>{status}</Tag>;
}
